export enum MethodsOfPayment {
	Check = 1,
	ACH = 2,
	CheckOverride = 3,
	PreNote = 4,
	EFT = 5,
	Cash = 6,
	CreditCard = 7,
	VirtualCard = 8,
}

export enum MethodsOfPaymentDescription {
	Check = 'Check',
	ACH = 'ACH',
	CheckOverride = 'Check Override',
	PreNote = 'Pre Note',
	EFT = 'EFT',
	Cash = 'Cash',
	CreditCard = 'Credit Card',
	VirtualCard = 'Virtual Card',
}
